//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
// import './style.scss';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Check } from 'src/onboarding/components/ui/check/Check';
import { Option } from 'src/onboarding/components/ui/check/Option';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const dailyDrinks = useStore((state) => state.dailyDrinks);
  const setDailyDrinks = useStore((state) => state.setDailyDrinks);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.dailyDrink.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={dailyDrinks}
          onChange={(value) => {
            setDailyDrinks(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'daily-drink',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'coffee'}>
            <span>☕️</span> {t('onboarding.dailyDrink.options.coffee')}
          </Option>
          <Option value={'1-5 glasses'}>
            <span>🥛</span> {t('onboarding.dailyDrink.options.glasses1')}
          </Option>
          <Option value={'5-10 glasses'}>
            <span>🫙</span> {t('onboarding.dailyDrink.options.glasses5')}
          </Option>
          <Option value={'More than 10 glasses'}>
            <span>🫖</span> {t('onboarding.dailyDrink.options.more10')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
